import React from "react";

// Field descriptors come straight from the published ticket_form, so adding a
// field in the backoffice changes the player form with no frontend deploy. That
// only holds if this renderer stays descriptor-driven: no per-field special
// cases, and an unknown type degrades to a text input rather than vanishing.
export default function FieldRenderer({ field, value, error, onChange }) {
  const id = "supField-" + field.key;
  const required = !!field.required;
  const describedBy = error ? id + "-error" : undefined;

  const common = {
    id,
    name: field.key,
    value: value === undefined || value === null ? "" : value,
    required,
    "aria-invalid": error ? "true" : undefined,
    "aria-describedby": describedBy,
    onChange: (event) => onChange(field.key, event.target.value),
  };

  let control;
  if (field.type === "textarea") {
    control = <textarea {...common} className="supInput supTextarea" rows={4} maxLength={field.max} />;
  } else if (field.type === "select") {
    control = (
      <select {...common} className="supInput">
        <option value="">{field.placeholder || ""}</option>
        {(field.options || []).map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  } else if (field.type === "checkbox") {
    control = (
      <input
        id={id}
        name={field.key}
        type="checkbox"
        className="supCheckbox"
        checked={!!value}
        required={required}
        aria-invalid={error ? "true" : undefined}
        aria-describedby={describedBy}
        onChange={(event) => onChange(field.key, event.target.checked)}
      />
    );
  } else {
    const type = ["email", "tel", "number", "date"].indexOf(field.type) !== -1 ? field.type : "text";
    control = <input {...common} type={type} className="supInput" maxLength={field.max} />;
  }

  return (
    <div className={"supField" + (field.type === "checkbox" ? " isCheckbox" : "")}>
      <label className="supLabel" htmlFor={id}>
        {field.label || field.key}
        {required && (
          <span className="supRequired" aria-hidden="true">
            *
          </span>
        )}
      </label>
      {control}
      {field.help && <p className="supHelp">{field.help}</p>}
      {error && (
        <p className="supFieldError" id={id + "-error"}>
          {error}
        </p>
      )}
    </div>
  );
}
